import { Injectable } from '@angular/core';
import { SlokaTypeDataService } from '../data/sloka-type.service';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import {
  SlokaTypeModel,
  AddSlokaTypeModel,
  SlokaTypeBackendModel,
  UpdateSlokaTypeModel,
} from '../interfaces/interfaces';
import { SlokaLogicService } from './sloka.service';
import { PassDataService } from '../services/pass-data.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SlokaTypeLogicService {
  deleteId: string = '';
  deleteImageName: string = '';

  constructor(
    private slokaTypeDataService: SlokaTypeDataService,
    private slokaLogicService: SlokaLogicService,
    private passDataService: PassDataService
  ) {}

  getAllSlokaTypesLogic(): Observable<SlokaTypeModel[]> {
    return this.slokaTypeDataService.getAllSlokaTypesData().pipe(
      switchMap((d) => {
        let slokaTypesList = [];
        for (let i = 0; i < d.length; i++) {
          let slokaType = d[i] as SlokaTypeBackendModel;

          let slokaTypeModel = new SlokaTypeModel(
            slokaType._id,
            slokaType.title,
            slokaType.description,
            0,
            slokaType.imageUrl
          );

          slokaTypesList.push(slokaTypeModel);
        }
        return [slokaTypesList];
      })
    );
  }

  addSlokaTypeLogic(title: string, description: string, file: any) {
    return this.slokaTypeDataService
      .uploadSlokaTypeImageData(file, moment().valueOf() + '-' + 'sloka-type')
      .pipe(
        first(),
        map((v) =>
          this.slokaTypeDataService.addSlokaTypeData(
            new AddSlokaTypeModel(title, description, v)
          )
        ),
        mergeAll()
      );
  }

  updateSlokaTypeLogic(
    title: string,
    description: string,
    file: any,
    link: any,
    id: string
  ) {
    if (file != null) {
      return this.slokaTypeDataService
        .uploadSlokaTypeImageData(file, link.split('/')[3])
        .pipe(
          first(),
          map((v) =>
            this.slokaTypeDataService.updateSlokaTypeData(
              new UpdateSlokaTypeModel(title, description, v, id)
            )
          ),
          mergeAll()
        );
    } else {
      return this.slokaTypeDataService.updateSlokaTypeData(
        new UpdateSlokaTypeModel(title, description, link, id)
      );
    }
  }

  deleteSlokaTypeLogic(slokaTypeId: string, link: string) {
    return this.slokaTypeDataService.deleteSlokaTypeData(slokaTypeId, link);
  }

  slokaTypeAndItsSlokasDeleteLogic(e: any) {
       
    return this.passDataService.getAllSlokaTypes().pipe(
      switchMap((l) => [l.filter((m) => e.data.id == m.id && m)]),
      switchMap((t) => {
        if (typeof t[0] != 'undefined') {
          this.deleteId = t[0].id;
          this.deleteImageName = t[0].imageUrl.split('/')[1];
        }
        return this.passDataService.getAllSlokas().pipe(
          switchMap((m) => {
            let slokas$: any[] = [];
            m.map(
              (sm) =>
                sm.slokaTypeId == t[0].id &&
                slokas$.push(this.slokaLogicService.deleteSlokaLogic(sm._id))
            );

            return slokas$.length === 0 ? of(slokas$) : forkJoin([...slokas$]);
          })
        );
      }),
      switchMap((v: any[]) =>
        this.deleteSlokaTypeLogic(this.deleteId, this.deleteImageName)
      )
    );
  }
}
